'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'tag';
var width = 576;
var height = 512;
var aliases = [127991];
var unicode = 'f02b';
var svgPathData = 'M72.4 16l-24 0 0 257.9 7 7 224 224 17 17 17-17 224-224 17-17-17-17-224-224-7-7-233.9 0zm24 238.1l0-190.1 190.1 0 200 200-190.1 190.1-200-200zm80-78.1a32 32 0 1 0 0-64 32 32 0 1 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTag = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;